import { Avatar, Grid, Typography, Button, Modal, Box } from "@mui/material";
import React, { useState } from "react";
import { ModalClose, ModalDialog } from "@mui/joy";
import { useTranslation } from "react-i18next";

const style = {
  width: { xs: "100%", md: 500 },
  maxWidth: { xs: "100%", md: 500 },
};

const titleStyle = {
  fontSize: '1.0rem',
  color: '#00796b',
  fontWeight: 'bold',
};

const detailStyle = {
  fontSize: '0.7rem',
};

const OrderDetails = ({ order }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button color="success" variant="outlined" onClick={handleOpen}>
        {"More Details"}
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalDialog
          color="neutral"
          variant="soft"
          sx={{ maxWidth: "100%", maxHeight: "100%", overflow: "auto" }}
        >
          <ModalClose onClick={handleClose} />
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              {"Order Details"}
            </Typography>

            {/* User Details Section */}
            <div className="order-detail-section">
              <Typography variant="h6" component="p" sx={titleStyle}>
                User Details
              </Typography>
              <div className="border" />
              <Typography variant="body1" component="p" sx={detailStyle}>
                {order.user.name}
              </Typography>
              <Typography
                variant="body2"
                component="p"
                sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
              >
                {order.user.phone}
              </Typography>
            </div>

            <div className="border" />

            {/* Driver Details Section */}

            {order.driver !== null ? <div className="order-detail-section">
              <Typography variant="h6" component="p" sx={titleStyle}>
                Driver Details
              </Typography>
              <div className="border" />
              <Typography variant="body1" component="p" sx={detailStyle}>
                Dennis King
              </Typography>
              <Typography
                variant="body2"
                component="p"
                sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
              >
                0712910072
              </Typography>
              <Typography
                variant="body2"
                component="p"
                sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
              >
                Vehicle Type : Uber
              </Typography>
            </div> : <></>}

            <div className="border" />

            {/* Partner Details Section */}
            <Typography variant="h6" component="p" sx={titleStyle}>
              Vendor Details
            </Typography>
            <div className="order-detail-img-wrapper">
              <Avatar
                size="xl"
                src={order?.vendor?.logo}
                sx={{ marginRight: 2 }}
              />


              <div className="order-detail-desc">
                <Typography variant="body1" component="p" sx={detailStyle}>
                  {order?.vendor?.name}
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
                >
                  {order?.vendor?.address}
                </Typography>
              </div>
            </div>

            <div className="border" />

            {/* Order Items Section */}
            <Typography variant="h6" component="p" sx={titleStyle}>
              Items & Order Summary
            </Typography>
            <div className="order-details-wrapper">
              {order?.products.map((order_data, index) => (
                <div key={index}>
                  <Typography
                    variant="body2"
                    component="p"
                    sx={{ fontWeight: 600, fontSize: detailStyle.fontSize }}
                  >
                    {order_data.product.name}
                  </Typography>
                  <Grid container>
                    <Grid item md={10}>
                      <Typography variant="body2" component="p" sx={detailStyle}>
                        <span>{order_data.quantity}</span> × {"Kshs."}{order_data.price}
                      </Typography>
                    </Grid>
                    <Grid item md={2} sx={{ textAlign: "end" }}>
                      <Typography variant="body2" component="p" sx={detailStyle}>
                        {"Kshs."}{order.sub_total}
                      </Typography>
                    </Grid>
                  </Grid>
                  <div className="border" />
                </div>
              ))}
            </div>

            {/* Total Amount Section */}
            <div className="order-total">
              <Grid container>
                <Grid item md={6} className="order-details">
                  <Typography variant="body1" component="p" sx={{ fontWeight: 600 }}>
                    {t("total")}
                  </Typography>
                  <Typography variant="body1" component="p" sx={detailStyle}>
                    {t("taxes_and_charges")}
                  </Typography>
                  <Typography variant="body1" component="p" sx={detailStyle}>
                    {t("Delivery Charges")}
                  </Typography>
                  <Typography variant="body1" component="p" sx={detailStyle}>
                    {t("total_pay")}
                  </Typography>
                </Grid>
                <Grid item md={6} sx={{ textAlign: "end" }} className="order-details">
                  <Typography variant="body1" component="p" sx={{ fontWeight: 600 }}>
                    {"Kshs."} {order?.sub_total}
                  </Typography>
                  <Typography variant="body1" component="p" sx={detailStyle}>
                    {"Kshs."} {order?.tax}
                  </Typography>
                  <Typography variant="body1" component="p" sx={detailStyle}>
                    {"Kshs."} {order?.delivery_fee ?? 0}
                  </Typography>
                  <Typography variant="body1" component="p" className="values" sx={detailStyle}>
                    {"Kshs."} {order?.total}
                  </Typography>
                </Grid>
              </Grid>
            </div>

            <div className="border" />

            {/* Grand Total Section */}
            <div className="total">
              <Grid container>
                <Grid item md={6}>
                  <Typography variant="body1" component="p" className="bold">
                    {t("grand_total")}
                  </Typography>
                </Grid>
                <Grid item md={6} sx={{ textAlign: "end" }}>
                  <Typography variant="body1" component="p" className="bold">
                  {"Kshs."} {order?.total}
                  </Typography>
                </Grid>
              </Grid>
            </div>

            <div className="border" />
            {/* Address Details Section */}
            <Typography variant="h6" component="p" sx={titleStyle}>
              Addresses
            </Typography>
            <div className="order-detail-img-wrapper">

              <div className="order-detail-desc">
                <Typography variant="body1" component="p" sx={detailStyle}>
                  Pickup Address
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
                >
                 {order?.delivery_address?.name??"--"}
                </Typography>
              </div>
              <div className="order-detail-desc">
                <Typography variant="body1" component="p" sx={detailStyle}>
                  Drop Off Address
                </Typography>
                <Typography
                  variant="body2"
                  component="p"
                  sx={{ color: "var(--light-color--)", fontSize: detailStyle.fontSize }}
                >
                 {order?.delivery_address?.address??"--"}
                </Typography>
              </div>
            </div>


            <Button
              variant="contained"
              fullWidth
              onClick={handleClose}
              sx={{ mt: 2 }}
            >
              Close
            </Button>
          </Box>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default OrderDetails;
